import { render, staticRenderFns } from "./PendingReceiving.vue?vue&type=template&id=c694ce84&scoped=true&"
import script from "./PendingReceiving.vue?vue&type=script&lang=js&"
export * from "./PendingReceiving.vue?vue&type=script&lang=js&"
import style0 from "./PendingReceiving.vue?vue&type=style&index=0&id=c694ce84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c694ce84",
  null
  
)

export default component.exports